import * as axios from "axios";
import { webStore, clearAuth } from "store";

var axiosObjectTypesense = axios.default.create();

axiosObjectTypesense.defaults.baseURL = `https://${process.env.NEXT_PUBLIC_TYPESENSE_HOST}`;

axiosObjectTypesense.defaults.headers.common = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

axiosObjectTypesense.interceptors.response.use(
  function (response: any) {
    return response;
  },
  function (error: any) {
    if (error.message.includes("500")) {
      console.log("server error!");
    } else if (error.message.includes("403")) {
      webStore.dispatch(clearAuth());
    }
    return Promise.reject(error);
  }
);

export { axiosObjectTypesense };
